// src/components/property-types-carousel/property-types-carousel.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyTypesCardFragment on EGDSCardCarouselItem {\n    card {\n      ... on EGDSImageLinkCard {\n        title\n        description\n        egdsElementId\n        link {\n          action {\n            resource {\n              ... on HttpURI {\n                value\n                relativePath\n              }\n            }\n            useRelativePath\n            analytics {\n              linkName\n              referrerId\n              eventType\n            }\n            accessibility\n            target\n          }\n          image {\n            aspectRatio\n            description\n            url\n            thumbnailClickAnalytics {\n              referrerId\n              eventType\n              linkName\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyTypesCarouselContainerFragment on EGDSCarousel {\n    items {\n      ... on EGDSCardCarouselItem {\n        ...PropertyTypesCardFragment\n      }\n    }\n    nextButton {\n      accessibility\n    }\n    previousButton {\n      accessibility\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  query PropertyTypesCarouselQuery($context: ContextInput!, $configurationId: String, $destinationId: String) {\n    propertyTypesCarousel(context: $context, configurationId: $configurationId, destinationId: $destinationId) {\n      heading {\n        text\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      carousel {\n        ...PropertyTypesCarouselContainerFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React3 from "react";
import { gql as gql3, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkHeading } from "uitk-react-text";
// src/components/property-types-carousel/__private/__fragments/property-types-carousel-container.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/property-types-carousel/__private/__fragments/property-types-card.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkCard, UitkCardLink } from "@egds/react-core/cards";
import { UitkFigure, UitkFigureAspectRatioType } from "@egds/react-core/images";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";
import { UitkScrim, UitkScrimType } from "@egds/react-core/scrim";
import { UitkText } from "@egds/react-core/text";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
var fragment = gql(_templateObject());
var PropertyTypesCard = function(props) {
    var data = props.data, index = props.index;
    var card = data.card;
    var clickTracker = useClickTracker();
    var handleClick = function(clickAction) {
        clickTracker(clickAction.analytics.referrerId, clickAction.analytics.linkName);
    };
    if (card.__typename !== "EGDSImageLinkCard") {
        return null;
    }
    var propertyCard = /* @__PURE__ */ React.createElement(UitkCard, {
        key: "property-types-image-".concat(index)
    }, card.link.action.resource.__typename === "HttpURI" && /* @__PURE__ */ React.createElement(UitkCardLink, null, /* @__PURE__ */ React.createElement("a", {
        href: card.link.action.resource.value,
        onClick: function() {
            return handleClick(card.link.action);
        }
    }, card.link.action.accessibility || card.title)), /* @__PURE__ */ React.createElement(UitkLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R3_4,
        src: card.link.image.url
    }, /* @__PURE__ */ React.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            zindex: "layer1",
            bottom: "two",
            left: "two"
        }
    }, /* @__PURE__ */ React.createElement(UitkText, {
        theme: "inverse",
        size: 400,
        weight: "bold"
    }, card.title)), /* @__PURE__ */ React.createElement(UitkScrim, {
        type: UitkScrimType.BOTTOM
    }))));
    return /* @__PURE__ */ React.createElement(React.Fragment, null, card.link.image.thumbnailClickAnalytics ? /* @__PURE__ */ React.createElement(IntersectionTracker, {
        referrerId: card.link.image.thumbnailClickAnalytics.referrerId,
        linkName: card.link.image.thumbnailClickAnalytics.linkName,
        intersectionOptions: {
            threshold: 0.75
        }
    }, propertyCard) : propertyCard);
};
PropertyTypesCard.fragment = fragment;
PropertyTypesCard.displayName = "PropertyTypesCard";
// src/components/property-types-carousel/__private/__fragments/property-types-carousel-container.tsx
var fragment2 = gql2(_templateObject1(), PropertyTypesCard.fragment);
var PropertyTypesCarouselContainer = function(props) {
    var data = props.data, children = props.children;
    var items = data.items, nextButton = data.nextButton, previousButton = data.previousButton;
    var itemsVisible = {
        sm: 2,
        md: 3,
        lg: 5
    };
    var carouselProps = {
        carouselName: "PropertyTypesCarousel",
        buttonText: {
            nextButton: (nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibility) || "",
            prevButton: (previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibility) || ""
        },
        itemsVisible: itemsVisible,
        itemsMaxHeight: true,
        pageBy: 1,
        peek: true,
        useContainerSizing: false,
        children: children
    };
    var PropertyTypesItems = items.map(function(propertyTypesItems, index) {
        if (propertyTypesItems.__typename === "EGDSCardCarouselItem") {
            return /* @__PURE__ */ React2.createElement(PropertyTypesCard, {
                key: "property-types-image-".concat(index),
                index: index,
                data: propertyTypesItems
            });
        }
        return null;
    });
    return /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkCarousel, _object_spread({}, carouselProps), PropertyTypesItems))), /* @__PURE__ */ React2.createElement(ViewMedium, null, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React2.createElement(UitkCarousel, _object_spread({}, carouselProps), PropertyTypesItems))), /* @__PURE__ */ React2.createElement(ViewLarge, null, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React2.createElement(UitkCarousel, _object_spread_props(_object_spread({}, carouselProps), {
        peek: false
    }), PropertyTypesItems))));
};
PropertyTypesCarouselContainer.fragment = fragment2;
PropertyTypesCarouselContainer.displayName = "PropertyTypesCarouselContainer";
// src/components/property-types-carousel/property-types-carousel.tsx
var __Query = gql3(_templateObject2(), PropertyTypesCarouselContainer.fragment);
var PropertyTypesCarousel = function(props) {
    var _data_propertyTypesCarousel;
    var skipSsr = props.skipSsr, inputs = props.inputs;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            useApq: true
        },
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var propertyTypesCarousel = data === null || data === void 0 ? void 0 : data.propertyTypesCarousel;
    var impressionAnalytics = data === null || data === void 0 ? void 0 : (_data_propertyTypesCarousel = data.propertyTypesCarousel) === null || _data_propertyTypesCarousel === void 0 ? void 0 : _data_propertyTypesCarousel.impressionAnalytics;
    var _ref = impressionAnalytics || {}, _ref_linkName = _ref.linkName, linkName = _ref_linkName === void 0 ? "" : _ref_linkName, _ref_referrerId = _ref.referrerId, referrerId = _ref_referrerId === void 0 ? "" : _ref_referrerId;
    if (loading || error || !propertyTypesCarousel) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, /* @__PURE__ */ React3.createElement(Viewport2, null, /* @__PURE__ */ React3.createElement(ViewSmall2, null, /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkHeading, {
        tag: "h2",
        size: 5
    }, propertyTypesCarousel.heading.text), /* @__PURE__ */ React3.createElement(PropertyTypesCarouselContainer, {
        data: propertyTypesCarousel.carousel
    }))), /* @__PURE__ */ React3.createElement(ViewMedium2, null, /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkHeading, {
        tag: "h2",
        size: 4
    }, propertyTypesCarousel.heading.text), /* @__PURE__ */ React3.createElement(PropertyTypesCarouselContainer, {
        data: propertyTypesCarousel.carousel
    })))));
};
PropertyTypesCarousel.displayName = "sharedui-PropertyTypesCarousel";
export { PropertyTypesCarousel };
//# sourceMappingURL=index.js.map